import React from 'react'
import createSvgIcon from '../utilities/createSvgIcon'

export default createSvgIcon(
  <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" />,
  'KeyboardArrowUp',
)
